module.exports = __webpack_public_path__ + "static/media/12.841a8002.jpg";